interface CompassProps {
  heading: number;
  onFaceNorth: () => void;
}

const CARDINALS = [
  { label: 'N', angle: 0 },
  { label: 'E', angle: 90 },
  { label: 'S', angle: 180 },
  { label: 'O', angle: 270 },
];

/** Shows where north is relative to the current view. Clicking it turns the view to the north. */
export default function Compass({ heading, onFaceNorth }: CompassProps) {
  const rounded = Math.round(heading) % 360;
  return (
    <button
      type="button"
      className="compass"
      onClick={onFaceNorth}
      title="Boussole : cliquer pour regarder vers le nord"
      aria-label={`Boussole, cap actuel ${rounded} degrés. Regarder vers le nord`}
    >
      <span className="compass__rose" style={{ transform: `rotate(${-heading}deg)` }}>
        {CARDINALS.map(({ label, angle }) => (
          <span key={label} className={`compass__mark ${label === 'N' ? 'compass__mark--north' : ''}`} style={{ transform: `rotate(${angle}deg)` }}>
            <span style={{ transform: `rotate(${-angle + heading}deg)` }}>{label}</span>
          </span>
        ))}
        <span className="compass__needle" />
      </span>
    </button>
  );
}
